import _ from 'lodash';
import { REQUEST_MEAS, RECEIVE_MEAS, FAILURE_MEAS } from './constants';
import { CALL_API } from '../../middlewares/api';

const shouldFetchMeas = (state, idType) => {
    const mea = state.mea[idType] || {};
    const meas = mea.meas;
    const fetching = mea.fetching;

    if (fetching) {
        return false;
    } else if (_.isEmpty(meas)) {
        return true;
    } else {
        return false;
    }
};

export const fetchMeasIfNeeded = (idType, callback) => {
    return {
        [CALL_API]: {
            endpoint: `/meas?idType=${idType}`,
            types: [REQUEST_MEAS, RECEIVE_MEAS, FAILURE_MEAS],
            shouldCallAPI: state => shouldFetchMeas(state, idType),
            payload: { idType },
            successCallback: (response, dispatch) => {
                if (callback) {
                    callback();
                }
            }
        }
    };
};

export const fetchMeasWithoutSegmentsIfNeeded = (idType, callback) => {
    return {
        [CALL_API]: {
            endpoint: `/meas/all?idType=${idType}`,
            types: [REQUEST_MEAS, RECEIVE_MEAS, FAILURE_MEAS],
            shouldCallAPI: state => shouldFetchMeas(state, idType),
            payload: { idType },
            successCallback: (response, dispatch) => {
                if (callback) {
                    callback();
                }
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/mea/actions.js